"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsTrainSortColumn = exports.EventsStationSortColumn = void 0;
var EventsStationSortColumn;
(function (EventsStationSortColumn) {
    EventsStationSortColumn["DataAlarmStatus"] = "DataAlarmStatus";
    EventsStationSortColumn["EquipmentGroupName"] = "EquipmentGroupName";
    EventsStationSortColumn["EventLogDate"] = "EventLogDate";
    EventsStationSortColumn["TrainPosition"] = "TrainPosition";
})(EventsStationSortColumn || (exports.EventsStationSortColumn = EventsStationSortColumn = {}));
var EventsTrainSortColumn;
(function (EventsTrainSortColumn) {
    EventsTrainSortColumn["DataAlarmStatus"] = "DataAlarmStatus";
    EventsTrainSortColumn["EventType"] = "EventType";
    EventsTrainSortColumn["PointName"] = "PointName";
    EventsTrainSortColumn["EventLogDate"] = "EventLogDate";
    EventsTrainSortColumn["MeasureType"] = "MeasureType";
    EventsTrainSortColumn["UserLogin"] = "UserLogin";
    EventsTrainSortColumn["DataValue1"] = "DataValue1";
})(EventsTrainSortColumn || (exports.EventsTrainSortColumn = EventsTrainSortColumn = {}));
//# sourceMappingURL=sort.js.map